package team.platforma.dictionary_domain

import team.platforma.dictionary_domain.use_case.ai_chapter.AiChapterTableUseCase
import team.platforma.dictionary_domain.use_case.ai_chapter.NetworkAiChapterUseCase
import team.platforma.dictionary_domain.use_case.ai_model.AiModelTableUseCase
import team.platforma.dictionary_domain.use_case.ai_model.NetworkAiModelUseCase

data class AiModelUseCase(
    val network: NetworkAiModelUseCase,
    val table: AiModelTableUseCase
)
